import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "home-fill--sprite",
  "use": "home-fill--sprite-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"home-fill--sprite\"><path d=\"M0 0h24v24H0z\" fill=\"none\" /><path d=\"M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol